import { createSlice } from "@reduxjs/toolkit";

/**
 * Stores role-based product feature access from admin/v1/checkProductStatusV5 (or similar).
 * Shape: { [role]: { [productKey]: { features, readFeatures, writeFeatures } } }
 * e.g. { "Superadmin": { "g_core": { features: [], readFeatures: [], writeFeatures: [] }, "i3": {...}, ... } }
 */
const initialState = {
  productAccessByRole: {},
};

const productAccessSlice = createSlice({
  name: "productAccess",
  initialState,
  reducers: {
    setProductAccessByRole(state, action) {
      const payload = action.payload;
      if (payload && typeof payload === "object" && !Array.isArray(payload)) {
        state.productAccessByRole = { ...state.productAccessByRole, ...payload };
      }
    },
    clearProductAccessByRole(state) {
      state.productAccessByRole = {};
    },
  },
});

export const { setProductAccessByRole, clearProductAccessByRole } = productAccessSlice.actions;
export default productAccessSlice.reducer;
